import Cookies from 'js-cookie';

import { LOCALES, SNEAKER_LOCALE_COOKIE_NAME } from 'localization/constants/configEnums';

const LOCALES_CONVERT = {
  en: LOCALES.enUS,
  fr: LOCALES.frFR,
};

// get sneaker locale from cookie
export const getLocale = () => {
  const localeFromCookie = Cookies.get(SNEAKER_LOCALE_COOKIE_NAME);

  return LOCALES_CONVERT?.[localeFromCookie] || LOCALES.enUS;
};
